import { PREFERRED_CONTACT_METHOD } from "@miplatform/constants";
import { getPhoneNumber } from "../inputHelper/inputHelper";

export const getPreferredContactValue = (item) => {
  if (!item) return "";

  switch (item.preferredContactMethod) {
    case PREFERRED_CONTACT_METHOD.Email:
      return item.email || "";
    case PREFERRED_CONTACT_METHOD.Phone:
      return getPhoneNumber(item.phone) || "";
    default:
      return "";
  }
};

export const getRequester = (requester) => {
  if (!requester) {
    return "";
  }

  const fullName = `${requester?.firstName} ${requester?.lastName}`;
  const contactInfo = getPreferredContactValue(requester);

  return contactInfo.length ? `${fullName}: ${contactInfo}` : fullName;
};
